import { UserActionTypes } from "./user-types";
import { GetProfile } from "../../services/api/profile-api";
import { GetDepartment } from "../../services/api/department-api";
import { GetRolePrivilege } from "../../services/api/role-privilege-api";
import { UserLogin } from '../../services/api/authentication-api';


export const getCurrentUser = async () => {
    try {
        const profile = await GetProfile();
        const department = await GetDepartment(profile.company);
        const privileges1 = await GetRolePrivilege(profile.role);

        let privileges = {};
        privileges1.forEach(privilege => {
            privileges[privilege.MenuItem] = privilege;
        });

        const user = {
            profile: profile,
            department: department,
            privileges: privileges,
        }

        return user;

    } catch (error) {
        console.log(error);
    }
}

export const getCurrentUserToken = async (userName, password) => {
    try{
        const currDateOffset = (new Date()).getTimezoneOffset();
        const loginObj = {username: userName, password: password, browserTime: currDateOffset};
        const result = await UserLogin(loginObj);
        const token = result.token
        return token
    }   
    catch (error){
        console.log(error)
    }
}

export const setCurrentUser = user => (
   {
        type: UserActionTypes.SET_CURRENT_USER,
        payload: user
    }
)

export const removeUser = user => (
   {
        type: UserActionTypes.REMOVE_USER,
        payload: user
    }
)